var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(-846.29 -2642.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(560 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "headlight-restoration",
    transform: "translate(889.141 2693.91)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 2.178,
    cy: 2.178,
    rx: 2.178,
    ry: 2.178,
    transform: "translate(40.655 40.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M70.79,34.948V32.169H68.011V28H65.232v4.169H62.453V28H59.674v4.169H56.9V28H54.116v4.169H51.337V28H48.558v4.169H43v1.39a6.933,6.933,0,0,0,.139,1.39h5.419v5.419a6.947,6.947,0,0,0,1.39.139h1.389V34.948h2.779v5.558H56.9V34.948h2.779v5.558h2.779V34.948h2.779v5.558h2.779V34.948Z",
    transform: "translate(15.359 9.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M45.324,49.232l-2.91-.193a1.371,1.371,0,0,0-1.351-1.2,2.464,2.464,0,0,1-2.34-1.685l-.51-1.528a1.39,1.39,0,0,0-2.64,0l-.509,1.528a2.466,2.466,0,0,1-2.339,1.685,1.376,1.376,0,0,0-1.035.484l-7.21-.484a1.36,1.36,0,0,0-1.042.372A1.39,1.39,0,0,0,23,49.232V56.18a4.327,4.327,0,0,0,4.081,4.32l20.842,1.235h.083a1.39,1.39,0,0,0,1.337-1.772l-2.779-9.727A1.39,1.39,0,0,0,45.324,49.232Zm-8.429-.67a5.173,5.173,0,0,0,.61.67,5.171,5.171,0,0,0-.61.67,5.171,5.171,0,0,0-.61-.67,5.172,5.172,0,0,0,.61-.67Zm-9.653,9.162a1.548,1.548,0,0,1-1.463-1.545V50.717l8.6.572a2.436,2.436,0,0,1,.695,1.017l.51,1.528a1.39,1.39,0,0,0,2.64,0l.509-1.528a2.48,2.48,0,0,1,.374-.7l5.068.339,1.973,6.9ZM49.4,32.558v1.389a8.345,8.345,0,0,0,8.337,8.337H78.58V39.506H75.8V35.337H78.58V32.558H75.8V29.779H78.58V27H54.959A5.558,5.558,0,0,0,49.4,32.558Zm5.558-2.779h1.389v2.779H52.18A2.779,2.779,0,0,1,54.959,29.779Zm4.169,5.558h2.779v4.169H59.127Zm5.558,0h2.779v4.169H64.685Zm0-2.779V29.779h2.779v2.779Zm-2.779,0H59.127V29.779h2.779Zm-9.529,2.779h3.971v3.971A5.558,5.558,0,0,1,52.377,35.337Zm20.645,4.169H70.243V35.337h2.779Zm0-6.948H70.243V29.779h2.779Z",
    transform: "translate(7.569 9.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M43.039,12.311l-3.054,8.142H38.517v-1.39a1.39,1.39,0,0,0-1.39-1.39h-1.6a41.352,41.352,0,0,0-8.1.8A5.206,5.206,0,0,0,28.439,28.79H34.7l-3.975,4.863a20.8,20.8,0,0,0-3,4.947A12.476,12.476,0,0,0,10.5,54.845L6.439,58.9a4.288,4.288,0,0,0-.641,5.28A25.205,25.205,0,0,0,1,78.911v8.238H3.779V78.911A22.408,22.408,0,0,1,7.917,66a4.289,4.289,0,0,0,1.588.311,4.366,4.366,0,0,0,3.067-1.27l4.06-4.06a12.271,12.271,0,0,0,9.379.432v3.508A11.379,11.379,0,0,0,27.4,70.36V82.981a4.169,4.169,0,0,0,4.169,4.169H42.685a4.169,4.169,0,0,0,4.169-4.169V77.862a155.427,155.427,0,0,0,17.062.95H87.149V76.033H63.915a152.556,152.556,0,0,1-28.041-2.6,8.662,8.662,0,0,1-7.084-8.513V60.023a12.506,12.506,0,0,0,5.558-10.391,1.1,1.1,0,0,0-.008-.165A125.009,125.009,0,0,0,53.8,51.022a1.435,1.435,0,0,0,1.034-.528,1.5,1.5,0,0,0,.329-1.151,17.113,17.113,0,0,0-16.984-15H33.744l6.9-8.436a203.438,203.438,0,0,1,32.837-2.68H87.149V20.453H73.483a206.343,206.343,0,0,0-31.44,2.429l3.6-9.6A14.719,14.719,0,0,1,59.359,3.779h27.79V1H59.359a17.508,17.508,0,0,0-16.32,11.311Zm-7.7,63.846c2.893.542,5.81.992,8.736,1.369v5.455a1.39,1.39,0,0,1-1.389,1.39H31.569a1.39,1.39,0,0,1-1.39-1.39V73.736a11.4,11.4,0,0,0,5.159,2.421ZM10.606,63.072a1.558,1.558,0,0,1-2.2-2.2l10.78-10.78a1.558,1.558,0,0,1,2.2,2.2Zm9.679-16.218a4.334,4.334,0,0,0-1.905.464,4.169,4.169,0,1,1,5.784,5.775,4.292,4.292,0,0,0,.457-1.9A4.341,4.341,0,0,0,20.285,46.854Zm1.558,12.506a9.727,9.727,0,0,1-3.075-.518l2.3-2.3a7.151,7.151,0,0,0,.771.043A6.948,6.948,0,1,0,14.9,49.633a7.033,7.033,0,0,0,.074.741l-2.334,2.334a9.715,9.715,0,1,1,9.208,6.652ZM33.913,46.414a4.14,4.14,0,0,0,.834.308c-.263-.042-.527-.076-.789-.121C33.945,46.54,33.931,46.477,33.913,46.414Zm.435-3.729a1.389,1.389,0,1,1,1.389,1.389A1.39,1.39,0,0,1,34.348,42.685ZM41.3,37.469A14.381,14.381,0,0,1,52.134,48.232a122.452,122.452,0,0,1-16.787-1.417c.128.013.253.039.385.039A4.169,4.169,0,1,0,31.643,41.9a12.6,12.6,0,0,0-1.583-1.667,17.957,17.957,0,0,1,1.588-3.1h6.531a14.358,14.358,0,0,1,3.12.343ZM36.974,26.011H28.439a2.427,2.427,0,0,1-.475-4.809,38.6,38.6,0,0,1,7.562-.749h.213v1.389a1.39,1.39,0,0,0,1.389,1.39h1.816l-.257.686Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M43,44.39A12.519,12.519,0,0,0,55.506,56.9H70.79V54.116H55.506a9.742,9.742,0,0,1-9.628-8.337H70.79V43h-26.4A1.39,1.39,0,0,0,43,44.39Z",
    transform: "translate(15.359 15.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 2.178,
    cy: 2.178,
    rx: 2.178,
    ry: 2.178,
    transform: "translate(40.655 40.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M11.965,18.447,11.7,17.112a1.39,1.39,0,0,0-2.723,0l-.267,1.33a7.7,7.7,0,0,1-5.655,5.932,1.39,1.39,0,0,0,0,2.7A7.7,7.7,0,0,1,8.708,33l.267,1.33a1.39,1.39,0,0,0,2.723,0L11.965,33a7.7,7.7,0,0,1,5.655-5.932,1.39,1.39,0,0,0,0-2.7A7.7,7.7,0,0,1,11.965,18.447ZM10.337,29.479a10.53,10.53,0,0,0-3.5-3.752,10.53,10.53,0,0,0,3.5-3.752,10.53,10.53,0,0,0,3.5,3.752,10.53,10.53,0,0,0-3.5,3.752Z",
    transform: "translate(-0.61 4.842)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlight);
export default __webpack_public_path__ + "static/media/headlight.1606fcd0874e14163cc43ec4ed24e82f.svg";
export { ForwardRef as ReactComponent };